<template>
  <tab-item-template>
    <template #toolbar-items>
      <v-spacer/>
      <v-btn text color="white" :href="`/hcs/api/v1/messages/${messageHistoryId}/certificate.pdf`" target="_blank">
        <v-icon class="mr-2">mdi-certificate-outline</v-icon>
        証明書発行
      </v-btn>
    </template>

    <el-table
        :data="serviceRecords">
      <el-table-column
          prop="id"
          label="ID"
          width="120">
      </el-table-column>

      <el-table-column
          prop="serviceComponentModelName"
          label="サービス実装">
      </el-table-column>

      <el-table-column
          prop="eventImplementationLocalId"
          label="イベント実装">
      </el-table-column>

      <el-table-column
          prop="result"
          label="結果値">
      </el-table-column>

      <el-table-column
          prop="note"
          label="付記">
      </el-table-column>

      <el-table-column
          width="160"
          prop="createdAt"
          label="利用日時">
        <template #default="{row}">{{ formatDateTime(row.createdAt) }}</template>
      </el-table-column>
    </el-table>
  </tab-item-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import Formatter from "@/utils/Formatter";

export default {
  name: 'ServiceRecordImplementationTable',
  mixins: [
    PathInfoMixin,
    Formatter
  ],
  components: {
    TabItemTemplate
  },
  props: {
    serviceRecords: {
      type: Array,
      required: true
    },
    messageId: {
      type: String,
      required: true
    },
    messageHistoryId: {
      type: String,
      required: true
    }
  }
}
</script>
